Vue.component('ppcarto-bar-action-item',{
  props: ['action','name','selected'],
  data (){
    return {
      from: null,
      to: null,
      selected: false,
    }
  },
  template: `
    <li class="topbar__btngrp__item" v-bind:class="[{'topbar__btngrp__item--selected': action.selected},action.key]">
      <a href="#" v-on:click="triggerAction" class="topbar__btngrp__link">
      <ppcarto-icon :name="action.key"></ppcarto-icon>
      </a>
      <div class="tooltip">
        <svg class="tooltip__arrow" viewBox="0 0 16 8">
          <!--<path d="M 0 0 L 16 0 L 8 8 z"></path>-->
          <path d="M 8 0 L 16 8 L 0 8 z"></path>
        </svg>
        <div class="tooltip__container">
          <p>{{name}}</p>
        </div>
      </div>
    </li>`,
  computed: {
    rome2rio (){
      return this.$store.getters.getRome2Rio;
    },
    name(){
      if(this.action.key == "rome2rio") {
        return "Anreise planen"
      } else {
        return "";
      }
    }

  },
  methods: {
    triggerAction (){
      this.$store.commit('toggleAction', this.action)
      if(this.action.key == "rome2rio") {
        this.$store.commit("setRome2Rio", {from:this.rome2rio.from, to:this.rome2rio.to, origin: this.rome2rio.origin, destination: this.rome2rio.destination, visible: !this.rome2rio.visible});
      }

    }
  },
  watch: {

  }

})
